import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from "@angular/core";

import { MessageService } from "../../../services/messageservice";

@Component({
  selector: "checktag",
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "checktag.html",
})
export class ChecktagComponent {
  private msgsrv = inject(MessageService);

  protected checktagTitle = input.required<string>();
  protected toggleChecktag = signal(false);

  constructor() {
    effect(() => {
      const msg = { type: "tag", value: this.checktagTitle() };
      if (this.toggleChecktag()) {
        this.msgsrv.enableFilter(msg);
      } else {
        this.msgsrv.disableFilter(msg);
      }
    });
  }

  toggleCheck() {
    this.toggleChecktag.update((value) => !value);
  }
}
